import fileSys from "../../fileoprators/fileSystem";
import { isFileExists, INVALID_1000, isDefined, getFilePath } from "../shared/index";
import { mockZernike } from "./mock";
const addonZK = window.__ct__.debug
  ? mockZernike
  : window.require(fileSys.getUtilPath("DEA520ZERK.node"));
let zernikePtr = null;
let zernikeWa = null;
let sicomatPath = fileSys.getUtilPath("sicomat_66_360.bin");
let zerkmat = fileSys.getUtilPath("zerkpolyrmat_66_301.bin");
let imgEPath = fileSys.getStaticImagePath("E.bmp");
let _casePath = "";
const MTFLEN = 401;
const PSFLEN = 400;
const INTERLEN = 201;
const EWIDTH = 1000;
const EHEIGHT = 1000;
const CRNF = "CRNF.RTH";
function isZernikePtrValid() {
  return isDefined(zernikePtr) && zernikePtr > 0;
}
function isZernikeWaValid() {
  return isDefined(zernikeWa) && zernikeWa > 0;
}
function isResultValid(result) {
  return isDefined(result) && result.result === 0;
}

class Zernike {
  initZernikeMod(casePath, step = 2) {
    _casePath = casePath;
    let result = addonZK.Initaberrationmod(step);

    zernikeWa = isResultValid(result) ? result.ptr : null;
    return isResultValid(result);
  }
  udateRpZnkOrder(order, diameter) {
    if (isZernikeWaValid() && isFileExists(sicomatPath)) {
      let result = this.UploadDataAndPrepar(order, diameter);
      if (!result) return false;
      result = addonZK.UpdateTypeRadius(zernikeWa, sicomatPath, zerkmat, 3, order, diameter);

      if (isResultValid(result)) {
        addonZK.ComputeAll(zernikeWa);

        result = addonZK.PorttoZernikemod(zernikeWa);
        if (isResultValid(result)) {
          zernikePtr = result.ptr;
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  getUIParams() {
    let values = new Float64Array(66);
    let nTerms = new Int32Array(1);
    values.fill(INVALID_1000);
    if (isZernikePtrValid()) {
      addonZK.UIGetZpara(zernikePtr, values.buffer, nTerms.buffer);
    }
    return values;
  }
  UploadDataAndPrepar(order, diameter) {
    let fullPath = getFilePath(_casePath, CRNF);
    if (isZernikeWaValid() && isFileExists(fullPath)) {
      let result = addonZK.UploaddataandPrepar(
        zernikeWa,
        fullPath,
        sicomatPath,
        zerkmat,
        order,
        diameter
      );

      return isResultValid(result);
    } else {
      return false;
    }
  }
  calcZnkMap(indexes) {
    if (isZernikePtrValid()) {
      let result = addonZK.CalcZnkMap(zernikePtr, indexes.buffer);

      return result.result === 0;
    } else {
      return false;
    }
  }
  getUIMaxXY() {
    if (isZernikePtrValid()) {
      let result = addonZK.UIGetMaxXY(zernikePtr);

      if (result.result === 0) {
        return {
          x: isNaN(result.maxX) ? INVALID_1000 : result.maxX,
          y: isNaN(result.maxY) ? INVALID_1000 : result.maxY
        };
      } else {
        return {
          x: INVALID_1000,
          y: INVALID_1000
        };
      }
    } else {
      return {
        x: INVALID_1000,
        y: INVALID_1000
      };
    }
  }
  getUIColorMapData() {
    let data = new Float64Array(601 * 601);
    if (isZernikePtrValid()) {
      let result = addonZK.UIGetColorMapData(zernikePtr, data.buffer);
      if (result.result === 0) {
        result.data = data;
        return result;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  getUIZnkparaKeys(indexes) {
    let meanRms = new Float64Array(2);
    meanRms.fill(INVALID_1000);
    if (isZernikePtrValid()) {
      addonZK.UIGetZnkparaKeys(zernikePtr, indexes.buffer, meanRms.buffer);

      return {
        mean: meanRms[0] * 1000,
        rms: meanRms[1] * 1000
      };
    } else {
      return {
        mean: INVALID_1000,
        rms: INVALID_1000
      };
    }
  }
  bmpData2Url(data, width, height) {
    let canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.style.visibility = "hidden";
    let cxt = canvas.getContext("2d");
    let bmpData = cxt.createImageData(width, height);
    for (let i = 0; i < data.length; i++) {
      bmpData.data[i * 4] = data[i];
      bmpData.data[i * 4 + 1] = data[i];
      bmpData.data[i * 4 + 2] = data[i];
      bmpData.data[i * 4 + 3] = 255;
    }

    cxt.clearRect(0, 0, cxt.width, cxt.height);
    cxt.putImageData(bmpData, 0, 0, 0, 0, width, height);
    return canvas.toDataURL("image/jpg");
  }
  getPsfInfo() {
    let psfInfo = this.getWaveAberrationPSFMTF();
    let retina = this.getRationalImage(psfInfo.psf1);
    let interInfo = this.getMTFExportIn2Section0_90(psfInfo.mtf1);
    return {
      export0: interInfo.inter0,
      export90: interInfo.inter90,
      ratio: psfInfo.ratio,
      psfUrl: this.bmpData2Url(psfInfo.psf1, PSFLEN, PSFLEN),
      eUrl: this.bmpData2Url(retina, EWIDTH, EHEIGHT)
    };
  }
  getWaveAberrationPSFMTF() {
    let mtf0 = new Float64Array(MTFLEN * MTFLEN);
    let mtf1 = new Float64Array(MTFLEN * MTFLEN);
    let psf0 = new Uint8Array(PSFLEN * PSFLEN);
    let psf1 = new Uint8Array(PSFLEN * PSFLEN);
    let ratio = 0;
    if (isZernikePtrValid()) {
      let obj = addonZK.WaveAberrationPSF_MTF(
        zernikePtr,
        psf0.buffer,
        psf1.buffer,
        mtf0.buffer,
        mtf1.buffer,
        PSFLEN
      );
      ratio = obj.strehlRatio;
    }
    return {
      mtf0: mtf0,
      mtf1: mtf1,
      psf0: psf0,
      psf1: psf1,
      ratio: ratio
    };
  }
  getMTFExportIn2Section0_90(mtf1) {
    let inter0 = new Float64Array(INTERLEN);
    let inter90 = new Float64Array(INTERLEN);
    addonZK.MTFexportin2section0_90(mtf1.buffer, inter0.buffer, inter90.buffer, INTERLEN);
    return {
      inter0: inter0,
      inter90: inter90
    };
  }
  getRationalImage(psf1, param = 1) {
    let retina = new Uint8Array(EWIDTH * EHEIGHT);
    addonZK.GetRetinaImage(imgEPath, psf1.buffer, retina.buffer, EWIDTH, EHEIGHT, param);
    return retina;
  }
  freeAberration() {
    if (isZernikeWaValid()) {
      addonZK.FreeAberration(zernikeWa);
      zernikeWa = null;
      zernikePtr = null;
    }
  }
}
export default Zernike;



// WEBPACK FOOTER //
// ./src/topography/js/zernike.js